import React from "react"

const SideNavButton = (props) => 
  <a data-target="slide-out" className="sidenav-trigger show-on-large" href = "/">
      <div></div>
  </a>;


export default SideNavButton;